const BattleCalc = require('./BattleCalc');

const getBattleStateHelperFuncs = ({ allTiles, allUnits }) => {
  const getTileAtCoords = (x, y) => {
    return Object.values(allTiles).find((t) => t.x === x && t.y === y);
  };

  const getAdjacentTiles = (piece) => {
    return Object.values(allTiles).filter((tile) => BattleCalc.adjacent(piece, tile));
  };

  const getEnemiesOfUnit = (unit) => {
    return Object.values(allUnits).filter(
      ({ team, dead, inPlay }) => !dead && inPlay && team != unit.team
    );
  };

  const getNearestEnemyOf = (unit, consider_heroes_only = false) => {
    let enemies = getEnemiesOfUnit(unit);
    if (!enemies.length) return null;

    if (consider_heroes_only) enemies = enemies.filter(({ hero, poppet }) => hero && !poppet);

    let nearest = enemies[0];
    let nearestDist = BattleCalc.boardDistance(unit, nearest);
    for (const enemy of enemies) {
      const dist = BattleCalc.boardDistance(unit, enemy);
      if (dist < nearestDist) {
        nearestDist = dist;
        nearest = enemy;
      }
    }

    return nearest;
  };

  return {
    getTileAtCoords,
    getAdjacentTiles,
    getEnemiesOfUnit,
    getNearestEnemyOf,
  };
};
module.exports = getBattleStateHelperFuncs;
